import { Component, ElementRef, ViewChild } from '@angular/core';
import { MdbModalRef, MdbModalService } from 'mdb-angular-ui-kit/modal';
import { MdbTableDirective } from 'mdb-angular-ui-kit/table';
import { ModalCompanyComponent } from 'src/app/components/crud/modal-company/modal-company.component';
import { ModalAppsComponent } from 'src/app/components/crud/modal-apps/modal-apps.component';
import { GenericCrudService } from 'src/app/services/crud/generic-crud.service';
import { Company, Apps } from 'src/app/models/interfaces.model';
import Swal from 'sweetalert2';
import { MdbFileUploadComponent } from 'mdb-angular-file-upload';
import { environment } from 'src/app/environments/environments';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MdbTabChange } from 'mdb-angular-ui-kit/tabs';
import { ModalMenuComponent } from 'src/app/components/crud/modal-menu/modal-menu.component';
import { ShowInfoSwal } from 'src/app/helpers/ShowInfoSwal';
import { ModalCloneProfileComponent } from 'src/app/components/crud/modal-clone-profile/modal-clone-profile.component';

@Component({
  selector: 'app-companies',
  templateUrl: './companies.component.html',
  styleUrls: ['./companies.component.css']
})
export class CompaniesComponent {

  @ViewChild('table') table!: MdbTableDirective<Company>;
  @ViewChild('fileUpload') fileUpload!: MdbFileUploadComponent;
  modalRef: MdbModalRef<ModalCompanyComponent> | null = null;
  modalRefApps: MdbModalRef<ModalAppsComponent> | null = null;
  modalRefMenu: MdbModalRef<ModalMenuComponent> | null = null;
  modalRefCloneProfile: MdbModalRef<ModalCloneProfileComponent> | null = null;

  loading = true;
  loadingFull = true;
  permissionForm: FormGroup


  headers = [
    { label: 'Empresa', field: 'NAME', disableSort: false },
    { label: 'Logo', field: 'LOGO', disableSort: false },
    { label: 'Aplicaciones', field: 'DOMAIN', disableSort: false },
  ];

  headersMenuTable = [
    { label: 'Empresa', field: 'NAME', disableSort: false },
    { label: 'Aplicaciones', field: 'DOMAIN', disableSort: false },
  ];

  firstTimeLoad: boolean = true
  dataSource: Company[] = [];
  AllApps: any[] = [];
  AllCompanies: any[] = [];
  AllChildrenMenus: any[] = [];
  isInsertMode: boolean = true; // Inicialmente en modo "INSERT"
  isUpdateMode: boolean = false;
  /* tab 2*/
  favoriteCompany: number | null = null;
  favoriteApp: string | null = null;
  infoUsers: any;
  AllUsers: any;
  selectedCompanies: string[] = [];
  selectedApps: string[] = [];
  AllCompaniesAndApps: any = [];
  infoCompaniesApps: Company[] = [];
  FormCompanyApps = new FormGroup({});
  infoCompanies: any;
  infoApps: Apps[] = [];
  selectedUser: number = 0;
  companiesInDataBase = 0;
  appsInDataBase = 0;
  MenuItems: any;
  infoMenus: Company[] = [];
  itemsMenuSelected: number[] = [];
  active: number = 0;

  /* end tab 2 */

  /* TAB MENU */

  responseData: any;

  constructor(
    private fb: FormBuilder,
    private modalService: MdbModalService,
    private crudService: GenericCrudService<Company>) {
    this.permissionForm = this.fb.group({})
  }

  onSwitchChange(checked: boolean) {
    this.isInsertMode = checked;
    this.isUpdateMode = !checked;
  }

  async onTabChange(event: MdbTabChange): Promise<void> {
    this.loadingFull = true;
    if (event.index == 0 && !this.firstTimeLoad) {
      await this.getAllCompanies();
      this.loadingFull = false
    }

    else if (event.index == 1) {
      this.firstTimeLoad = false;

      await Promise.all([
        this.getUsers(),
        this.getCompaniesApps(),

      ]);
      this.loadingFull = false
    }
    else if (event.index == 2) {
      this.firstTimeLoad = false;

      await Promise.all([
        this.getUsers(),
        //this.getCompanies(),

      ]);

      this.loadingFull = false
    }
    else if (event.index == 3) {
      this.firstTimeLoad = false;
      await Promise.all([
        this.getMenus(),
        this.getParentMenus(),
        this.getCompanies(),
        this.getCompaniesHasApps(),
      ]);
      this.loadingFull = false
    }
    else if (event.index == 4) {
      this.loadingFull = false
    }
  }
  async ngOnInit(): Promise<void> {

    this.permissionForm = this.fb.group({
      usersControlName: ['', Validators.required],
      companiesControlName: ['', Validators.required],
      appControlName: ['', Validators.required],
    });
    await this.getAllCompanies();

  }

  search(event: Event): void {
    const searchTerm = (event.target as HTMLInputElement).value;
    this.table.search(searchTerm);
  }

  async getAllCompanies(): Promise<void> {
    const body = new FormData();
    body.append('table_name', "COMPANIES");
    body.append('relations', "APPS");
    body.append('activeFilter', '0');



    return new Promise<void>((resolve, reject) => {
      this.crudService.crud(body, `${environment.EndPointCrud}`).subscribe((data: any) => {
        if (data && data.status === 1) {
          this.dataSource = data.data.COMPANIES.map((company: any) => {
            return {
              ID: company.ID,
              NAME: company.NAME,
              LOGO: company.LOGO,
              ACTIVE: company.ACTIVE,
              DATE_CREATE: company.DATE_CREATE,
              DATE_CREATE2: company.DATE_CREATE2,
              LOGO2: company.LOGO2,
              APPS: company.APPS.map((app: any) => {
                return {
                  ID_APP: app.ID_APP,
                  NAME_APP: app.NAME_APP,
                  LOGO_APP: app.LOGO_APP,
                  ACTIVE_APP: app.ACTIVE_APP,
                };
              }),
            };
          });

          this.AllApps = data.data.APPS.map((app: any) => {
            return {
              value: app.ID,
              label: app.NAME,
            };
          });


          this.AllCompanies = data.data.COMPANIES.map((company: any) => {
            return {
              value: company.ID,
              label: company.NAME,
            };
          });

          this.loading = false;
          this.loadingFull = false;
        } else {
          console.error('Error: No se pudo obtener la data de las compañías.');
        }
      }, error => {
        console.error('Error: ', error);
      });
    });

  }

  async getCompaniesHasApps(): Promise<void> {
    const body = new FormData();
    return new Promise<void>((resolve, reject) => {
      this.crudService.crud(body, `${environment.GetCompaniesHasApps}`).subscribe((result: any) => {
        if (result && result.status === 1) {
          this.AllCompaniesAndApps = result.data.map((company: any) => {
            return {
              ID: company.ID,
              NAME: company.NAME,
              LOGO: company.LOGO,
              ACTIVE: company.ACTIVE,
              DATE_CREATE: company.DATE_CREATE,
              DATE_CREATE2: company.DATE_CREATE2,
              LOGO2: company.LOGO2,
              APPS: company.APPS.map((app: any) => {
                return {
                  ID_APP: app.ID_APP,
                  NAME_APP: app.NAME_APP,
                  LOGO_APP: app.LOGO_APP,
                  ACTIVE_APP: app.ACTIVE_APP,
                };
              }),
            };
          });
          this.loading = false;
          this.loadingFull = false;
        } else {
          console.error('Error: No se pudo obtener la data de las compañías.');
        }
      }, error => {
        console.error('Error: ', error);
      });
    });

  }

  async openModal(mode: 'add' | 'edit', app?: Company | null, AllApps?: any): Promise<void> {
    this.modalRef = this.modalService.open(ModalCompanyComponent, {
      data: {
        modalTitle: mode === 'edit' ? 'Editar Empresa' : 'Nueva Empresa',
        company: app ? app.NAME : '',
        domain: app ? app.DOMAIN : '',
        dc: app ? app.DC : 1,
        active: app && parseInt(app.ACTIVE) === 1 ? 1 : 0,
        edit: mode === 'edit' ? 1 : 0,
        id: app ? app.ID : -1,
        logo: app ? app.LOGO : '',
        APPS: app?.APPS,
        ALLAPPS: AllApps ? AllApps : ''
      },
      ignoreBackdropClick: true,
    });
    this.modalRef.onClose.subscribe((modalData: Company) => {
      if (!modalData) {
        return;
      }
      if (mode === 'add') {
        this.dataSource = [...this.dataSource, { ...modalData }];
      } else if (mode === 'edit' && app) {
        const index = this.dataSource.indexOf(app);
        this.dataSource[index] = modalData;
        this.dataSource = [...this.dataSource];
      }
    });
    this.modalRef.component.OnGuardarClicked.subscribe(async () => {
      await this.getAllCompanies();
    });
  }

  onDeleteClick(data: Company): void {

    let title_ = data.ACTIVE === '1' ?
      "¿Realmente desea DESACTIVAR esta Empresa?" :
      "¿Realmente desea ACTIVAR esta Empresa?";

    let titleConfirm = data.ACTIVE === '1' ?
      "Desactivado" :
      "Activado";

    let deleteObj = {
      id: data.ID,
      table_name: 'COMPANIES',
      action: 'DELETE',
      active_option: parseInt(data.ACTIVE) == 1 ? 0 : 1
    }

    Swal.fire({
      title: title_,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Sí',
      cancelButtonText: 'Cancelar',
      allowOutsideClick: false
    }).then((result) => {
      if (result.isConfirmed) {
        Swal.fire({
          title: 'Procesando...',
          allowOutsideClick: false,
          showCancelButton: false,
          showCloseButton: false,
          showConfirmButton: false,
          willOpen: () => {
            Swal.showLoading();
            this.crudService.crud(deleteObj, environment.GenericCrudOperation).toPromise().then(() => {
              this.getAllCompanies();
              Swal.fire({
                icon: 'success',
                title: 'Registro ' + titleConfirm + ' correctamente',
                showConfirmButton: false,
                timer: 500
              });
            }).catch((error) => {
              // Control de error en caso de que falle la eliminación en el servidor
              Swal.fire({
                icon: 'error',
                title: 'Error al eliminar el registro',
                text: error.message,
                allowOutsideClick: false,
              });
            });
          }
        });
      }
    });

    this.loading = false;
    /*const index = this.dataSource.indexOf(data);
    this.dataSource.splice(index, 1);
    this.dataSource = [...this.dataSource];*/
  }

  //-------------- APPS -----------------------------//
  openModalApps(mode: 'add' | 'edit', apps: any, companyData?: any, ALLCOMPANYAPPS?: any): void {
    //async openModalApps(mode: 'add' | 'edit', apps: any, companyData?: any, ALLCOMPANYAPPS?: any): Promise<void> {
    this.modalRefApps = this.modalService.open(ModalAppsComponent, {
      data: {
        modalTitle: mode === 'edit' ? 'Editar Apps' : 'Nueva Apps',
        appsName: apps ? apps.NAME_APP : '',
        appLogo: apps ? apps.LOGO_APP : '',
        active: apps && parseInt(apps.ACTIVE_APP) === 1 ? 1 : 0,
        edit: mode === 'edit' ? 1 : 0,
        id: apps ? apps.ID_APP : -1,
        AllCompanies: companyData ? companyData : '',
        CompaniesApps: apps,
        ALLCOMPANYAPPS: ALLCOMPANYAPPS ? ALLCOMPANYAPPS : ''
      },
      ignoreBackdropClick: true,
    });
    this.modalRefApps.onClose.subscribe((modalData: any) => {
      if (!modalData) {
        return;
      }
      if (mode === 'add') {
        this.dataSource = [...this.dataSource, { ...modalData }];
      } else if (mode === 'edit' && apps) {
        const index = this.dataSource.indexOf(apps);
        this.dataSource[index] = modalData;
        this.dataSource = [...this.dataSource];
      }
    });
    this.modalRefApps.component.OnGuardarClicked.subscribe(async () => {
      await this.getAllCompanies();
    });
  }

  onDeleteClickApps(data: any, CompanyId: number): void {

    let title_ = parseInt(data.ACTIVE_APP) === 1 ?
      "¿Realmente desea DESACTIVAR esta APP?" :
      "¿Realmente desea ACTIVAR esta APP?";

    let titleConfirm = parseInt(data.ACTIVE_APP) === 1 ?
      "Desactivado" :
      "Activado";

    let deleteObj = {
      AppId: data.ID_APP,
      CompanyId: CompanyId,
      table_name: 'APPS',
      action: 'DELETE',
      Active: parseInt(data.ACTIVE_APP) == 1 ? 0 : 1
    }

    Swal.fire({
      title: title_,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Sí',
      cancelButtonText: 'Cancelar',
      allowOutsideClick: false
    }).then((result) => {
      if (result.isConfirmed) {
        Swal.fire({
          title: 'Procesando...',
          allowOutsideClick: false,
          showCancelButton: false,
          showCloseButton: false,
          showConfirmButton: false,
          willOpen: () => {
            Swal.showLoading();
            this.crudService.crud(deleteObj, environment.updateCompanyApps).toPromise().then(() => {
              this.getAllCompanies();
              Swal.fire({
                icon: 'success',
                title: 'Registro ' + titleConfirm + ' correctamente',
                showConfirmButton: false,
                timer: 1000
              });
            }).catch((error) => {
              // Control de error en caso de que falle la eliminación en el servidor
              Swal.fire({
                icon: 'error',
                title: 'Error al eliminar el registro',
                text: error.message,
                allowOutsideClick: false,
              });
            });
          }
        });
      }
    });

    this.loading = false;
    /*const index = this.dataSource.indexOf(data);
    this.dataSource.splice(index, 1);
    this.dataSource = [...this.dataSource];*/
  }

  /* tab 2 */

  onCompanyClick(companyId: number) {
    if (this.favoriteCompany != null && this.favoriteCompany != companyId)
      this.favoriteApp = null
    this.favoriteCompany = this.favoriteCompany === companyId ? null : companyId;
  }

  onAppClick(companyId: number, appId: number) {
    if (this.favoriteCompany != companyId) {
      this.favoriteCompany = null;
      this.favoriteCompany = companyId;
    }

    this.favoriteApp = this.favoriteApp === 'company-' + companyId + 'app-' + appId ? null : 'company-' + companyId + 'app-' + appId;
  }

  async getUsers(): Promise<void> {
    this.infoUsers = []
    const body = new FormData();
    body.append('action', "SELECT");
    body.append('table_name', "USERS");

    return new Promise<void>((resolve, reject) => {
      this.crudService.crud(body, environment.GenericCrudOperation).subscribe((data: any) => {

        if (data && data.status === 1 && data.data && data.data.length > 0) {
          this.infoUsers = data.data.map((element: any) => {
            return {
              value: element.ID,
              label: element.SAMACCOUNTNAME,
            };
          });

          resolve(); // Resuelve la promesa una vez completada la operación
        } else {
          console.error('Error: No se pudo obtener la data de logs1.');
          reject(); // Rechaza la promesa en caso de error
        }
      }, (error: any) => {
        console.error('Error: ', error);
        reject(); // Rechaza la promesa en caso de error
      });
    });
  }

  async getCompanies(): Promise<void> {
    const body = new FormData();
    body.append('action', "SELECT");
    body.append('table_name', "COMPANIES");

    return new Promise<void>((resolve, reject) => {
      this.crudService.crud(body, environment.GenericCrudOperation).subscribe((data: any) => {

        if (data && data.status === 1 && data.data) {
          this.infoCompanies = data.data.map((element: any) => {
            return {
              value: element.ID,
              label: element.NAME,
            };
          });

          resolve(); // Resuelve la promesa una vez completada la operación
        } else {
          console.error('Error: No se pudo obtener la data de logs1.');
          reject(); // Rechaza la promesa en caso de error
        }
      }, (error: any) => {
        console.error('Error: ', error);
        reject(); // Rechaza la promesa en caso de error
      });
    });
  }

  async getCompaniesApps(): Promise<void> {

    const body = new FormData();
    body.append('relations', "APPS");
    body.append('table_name', "COMPANIES");
    body.append('activeFilter', '1');

    return new Promise<void>((resolve, reject) => {
      this.crudService.crud(body, environment.EndPointCrud).subscribe((data: any) => {
        if (data && data.status === 1 && data.data && data.data.COMPANIES) {
          this.infoCompaniesApps = Object.values(data.data.COMPANIES);
          this.initializeForm();
          resolve(); // Resuelve la promesa una vez completada la operación
          this.loading = false;
        } else {
          console.error('Error: No se pudo obtener la data de logs2.');
          reject(); // Rechaza la promesa en caso de error
        }
      }, (error: any) => {
        console.error('Error: ', error);
        reject(); // Rechaza la promesa en caso de error
      });
    });
  }


  initializeForm() {
    this.infoCompaniesApps.forEach(company => {
      this.FormCompanyApps.addControl(`company-${company.ID}`, new FormControl(false));
      company.APPS.forEach(app => {
        this.FormCompanyApps.addControl(`company-${company.ID}app-${app.ID_APP}`, new FormControl(false));
      });
    });
  }

  onCompanyChange(companyId: string, isChecked: boolean): void {
    this.selectedCompanies = []
    if (isChecked) {
      this.selectedCompanies.push(companyId);
    } else {
      this.selectedCompanies = this.selectedCompanies.filter(id => id !== companyId);
    }
  }

  onAppChange(appId: string, isChecked: boolean): void {
    if (isChecked) {
      this.selectedApps.push(appId);
    } else {
      this.selectedApps = this.selectedApps.filter(id => id !== appId);
    }
  }

  onUserSelected(event: any): void {
    this.favoriteApp = null
    this.favoriteCompany = null
    this.loading = true
    console.log("event: ", event);
    const body = new FormData();
    body.append('table_name', "USERS");
    body.append('id', event);
    body.append('activeFilter', '1');
    this.selectedUser = event;

    this.crudService.crud(body, environment.EndPointCrud).subscribe((data: any) => {
      if (data && data.status === 1 && data.data && data.data.USERS && data.data.USERS.length > 0) {
        const user = data.data.USERS[0];
        if (user && user.COMPANIES) {
          for (const companyId of Object.keys(user.COMPANIES)) {
            const company = user.COMPANIES[companyId];
            if (company.IS_DEFAULT == 1)
              this.favoriteCompany = company.ID_COMPANY
            if (company && company.APPS) {
              for (const appId of Object.keys(company.APPS)) {
                const myApp = company.APPS[appId];
                if (myApp.IS_DEFAULT != 0) {
                  this.favoriteApp = `company-${companyId}app-${appId}`//myApp.IS_DEFAULT
                }
                const control = this.FormCompanyApps.get(`company-${companyId}app-${appId}`) as unknown as FormControl;
                if (control) {
                  control.setValue(true);
                } else {
                  console.error(`No se encontró el control 'company-${companyId}app-${appId}' en el formulario.`);
                }
              }
            }
            const companyControl = this.FormCompanyApps.get(`company-${companyId}`) as unknown as FormControl;
            if (companyControl) {
              companyControl.setValue(true);
            } else {
              console.error(`No se encontró el control 'company-${companyId}' en el formulario.`);
            }
          }
          this.loading = false
        }
      } else {
        this.resetForm();
        this.loading = false
        console.error('Error: No se pudo obtener la información del usuario seleccionado.');
      }
    }, (error: any) => {
      console.error('Error: ', error);
    });
  }

  async onUserSelectedTabPermission(event: any): Promise<void> {
    this.companiesInDataBase = 0
    this.permissionForm.get('companiesControlName')?.disable();
    this.selectedCompanies = []
    this.appsInDataBase = 0
    this.selectedApps = []
    this.loadingFull = true
    this.selectedUser = event
    this.infoCompanies = []
    this.infoApps = []
    this.selectedApps = []
    this.itemsMenuSelected  = []
    //this.loadingFull = true;

    this.permissionForm.get('companiesControlName')?.reset();
    this.permissionForm.get('appControlName')?.reset();

    const body = new FormData()
    body.append('id_user', event)

    return new Promise<void>((resolve, reject) => {
      this.crudService.crud(body, environment.getCompaniesByUserId).subscribe((data: any) => {
        if (data && data.status === 1 && data.data && data.data.length > 0) {
          this.companiesInDataBase = data.data.length
          if (this.companiesInDataBase > 0) {
            this.permissionForm.get('companiesControlName')?.enable();
          }
          else 
          this.permissionForm.get('companiesControlName')?.disable();
          this.infoCompanies = data.data.map((element: any) => {
            return {
              value: element.ID,
              label: element.NAME,
            };
          });
          resolve(); // Resuelve la promesa una vez completada la operación
        } else {
          this.itemsMenuSelected  = []
          this.infoCompanies = []
          this.infoApps = []
          this.companiesInDataBase = 0;
          this.permissionForm.get('companiesControlName')?.disable();
          this.appsInDataBase = 0;
          this.selectedApps = []
          //console.error('Error: No se pudo obtener la data de getCompaniesByUserId.');
          ShowInfoSwal(2, 'Error', 'El usuario seleccionado no tiene compañia(s) asignada(s)');
          resolve(); // resolver la promesa en caso de error para mostrar el mensaje de error y no un error en la consola
        }
        this.loadingFull = false;
      }, (error: any) => {
        //console.error('Error: ', error);
        reject(new Error(error)); // Rechaza la promesa en caso de error
      });
    });
  }

  async onCompanySelectedTabPermission(event: any): Promise<void> {
    this.permissionForm.get('appControlName')?.reset();
    this.appsInDataBase = 0
    this.selectedApps = []
    this.loadingFull = true
    this.selectedCompanies = []
    this.selectedCompanies.push(event)
    const body = new FormData()
    body.append('id_company', event)
    body.append('id_user', `${this.selectedUser}`)

    return new Promise<void>((resolve, reject) => {
      this.crudService.crud(body, environment.getAppsByParams).subscribe((data: any) => {
        if (data && data.status === 1 && data.data && data.data.length > 0) {
          this.infoApps = data.data.map((element: any) => {
            return {
              value: element.ID,
              label: element.NAME,
            };
          });
          resolve(); // Resuelve la promesa una vez completada la operación
        } else {
          this.appsInDataBase = 0
          console.error('Error: No se pudo obtener la data de logs1.');
          reject(); // Rechaza la promesa en caso de error
        }
        this.loadingFull = false;
      }, (error: any) => {
        console.error('Error: ', error);
        reject(); // Rechaza la promesa en caso de error
      });
    });
  }

  async onCompanySelectedTabMenu(event: any): Promise<any> {
    try {
      this.appsInDataBase = 0
      this.loadingFull = true
      this.selectedCompanies = []
      this.selectedCompanies.push(event)
      const body = new FormData()
      body.append('id_company', event)
      const data: any = await this.crudService.crud(body, environment.getAppsByParams).toPromise();

      if (data && data.status === 1 && data.data && data.data.length > 0) {
        this.appsInDataBase = data.data.length;
        this.infoApps = data.data.map((element: any) => {
          return {
            value: element.ID,
            label: element.NAME,
          };
        });
      } else {
        this.appsInDataBase = 0;
        console.error('Error: No se pudo obtener la data de logs1.');
      }
      return {
        appsInDataBase: this.appsInDataBase,
        infoApps: this.infoApps
      };
    } catch (error) {
      console.error('Error: ', error);
      throw error;
    } finally {
      this.loadingFull = false;
    }
  }

  // Función recursiva para procesar los menús y submenús
  CheckMenu(menuData: any) {
    if (!menuData) return; // Salir si no hay datos

    menuData.forEach((item: any) => {
      const menu = item.menu;

      // Agregar el menú actual a itemsMenuSelected si USER_HAS_MENU es 1
      if (menu.USER_HAS_MENU == 1)
        this.itemsMenuSelected.push(parseInt(menu.ID));

      // Si hay submenús, llamar recursivamente a CheckMenu
      if (menu.SUBMENUS) {
        this.CheckMenu(Object.values(menu.SUBMENUS));
      }
    });
  }

  

  async onAppSelectedTabPermission(event: any): Promise<void> {
    this.loadingFull = true
    this.selectedApps = []
    this.selectedApps.push(event)
    const body = new FormData()
    body.append('id_user', `${this.selectedUser}`)
    body.append('id_company', this.permissionForm.value.companiesControlName)
    body.append('id_app', event)

    return new Promise<void>((resolve, reject) => {
      this.crudService.crud(body, environment.getMenusByParams).subscribe((data: any) => {
        if (data && data.status === 1 && data.data) {
          this.MenuItems = [];
          this.itemsMenuSelected = []; // Limpiar la lista antes de llenarla nuevamente

          // Llamar a la función recursiva para procesar los menús y submenús
          this.CheckMenu(data.data);

          data.data.forEach((item: any) => {
            const menu = item.menu;
            const submenus = menu.SUBMENUS ? Object.values(menu.SUBMENUS).map((submenu: any) => ({
              submenuName: submenu.menu.NOMBRE,
              submenuId: submenu.menu.ID,
              UserHasMenu:submenu.menu.USER_HAS_MENU,
            })) : [];

            this.MenuItems.push({
              menuName: menu.NOMBRE,
              menuId: menu.ID,
              submenus: submenus,
              UserHasMenu: menu.USER_HAS_MENU
            });
          });
          this.appsInDataBase = this.MenuItems.length;
          resolve(); // Resuelve la promesa una vez completada la operación
        } else {
          this.appsInDataBase = 0;
          console.error('Error: No se pudo obtener la data del backend.');
          reject(); // Rechaza la promesa en caso de error
        }
        this.loadingFull = false;
      }, (error: any) => {
        console.error('Error: ', error);
        reject(); // Rechaza la promesa en caso de error
      });
    });



  }

  resetForm(): void {
    this.FormCompanyApps.reset();
  }


  InsertOrUpdate(): void {
    const registers: any = [];
    this.infoCompaniesApps.forEach((company, index) => {
      if (this.FormCompanyApps.get(`company-${company.ID}`)?.value) {

        company.APPS.forEach(app => {
          if (this.FormCompanyApps.get(`company-${company.ID}app-${app.ID_APP}`)?.value) {
            registers.push({
              idCompany: company.ID,
              idApp: app.ID_APP
            });
          }
        });
      }
    });

    const myAppId = this.favoriteApp ? this.favoriteApp.charAt(this.favoriteApp.length - 1) : null;

    const item = registers.find((item: { idApp: number | null; idCompany: number | null; }) => {
      return item.idApp === myAppId && item.idCompany === this.favoriteCompany;
    });


    if (item) {
      item.isDefault = 1;
    }

    const objRegisters = {
      idUser: this.selectedUser,
      registers: registers
    }
    let title_ = "¿Confirma que desea guardar la selección realizada?";

    let titleConfirm = "Datos Guardados existosamente!"

    Swal.fire({
      title: title_,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Sí',
      cancelButtonText: 'Cancelar',
      allowOutsideClick: false
    }).then((result) => {
      if (result.isConfirmed) {
        Swal.fire({
          title: 'Procesando...',
          allowOutsideClick: false,
          showCancelButton: false,
          showCloseButton: false,
          showConfirmButton: false,
          willOpen: () => {
            Swal.showLoading();
            this.crudService.crud(objRegisters, environment.createOrUpdateUserCompanyApps).toPromise().then(() => {
              this.onUserSelected(this.selectedUser)
              Swal.fire({
                icon: 'success',
                //title: 'Registro '+titleConfirm+' correctamente',
                title: ' ' + titleConfirm + ' ',
                showConfirmButton: false,
                timer: 500
              });
            }).catch((error) => {
              // Control de error en caso de que falle la eliminación en el servidor
              Swal.fire({
                icon: 'error',
                title: 'Error al eliminar el registro',
                text: error.message,
                allowOutsideClick: false,
              });
            });
          }
        });
      }
    });
    this.loading = false;
  }

  onCompanyMouseOver(companyId: number) {
  }

  onAppMouseOver(appId: number) {
  }

  /*  end tab 2 */


  /* TAB MENU */

  async openModalMenu(mode: 'add' | 'edit', menu?: any | null, AllCompaniesAndApps?: any, infoMenus?: any, AllChildrenMenus?: any): Promise<void> {
    console.log("menu selected: ", menu);
    this.modalRefMenu = this.modalService.open(ModalMenuComponent, {
      modalClass: 'modal-xl',
      data: {
        modalTitle: mode === 'edit' ? 'Editar Menu' : 'Nuevo Menu',
        edit: mode === 'edit' ? 1 : 0,
        AllCompaniesAndApps: AllCompaniesAndApps ? AllCompaniesAndApps : '',
        infoMenus,
        AllChildrenMenus,
        id: menu ? menu.ID : -1,
        isDynamicCheck: menu ? menu.ISDINAMYC : 1,
        checkSubMenu: menu ? menu.PARENT : 0,
        archivoMenu: menu ? menu.ICON : null,
        routes_config_component_name: menu ? menu.ROUTES_CONFIG_COMPONENT_NAME : '',
        routes_config_module_name: menu ? menu.ROUTES_CONFIG_MODULE_NAME : '',
        routes_config_module_path: menu ? menu.ROUTES_CONFIG_MODULE_PATH : '',
        routes_config_path: menu ? menu.ROUTES_CONFIG_PATH : '',
        path: menu ? menu.PATH : '',
        name: menu ? menu.NAME : '',
        activeMenu: menu ? menu.ACTIVE : 0,
      },
      ignoreBackdropClick: true,
    });
    this.modalRefMenu.onClose.subscribe((modalData: any) => {
      if (!modalData) {
        return;
      }
      if (mode === 'add') {
        this.dataSource = [...this.dataSource, { ...modalData }];
      } else if (mode === 'edit' && menu) {
        const index = this.dataSource.indexOf(menu);
        this.dataSource[index] = modalData;
        this.dataSource = [...this.dataSource];
      }
    });
    this.modalRefMenu.component.OnGuardarClicked.subscribe(async () => {
      await this.getMenus();
    });
  }

  async getMenus(): Promise<void> {
    try {
      const body = new FormData();
      body.append('table_name', "MENU");

      const result: any = await this.crudService.crud(body, environment.EndPointCrud).toPromise();
      if (result && result.status === 1 && result.data && result.data.length > 0) {
        this.infoMenus = Object.values(result.data);
      } else {
        console.error('Error: No se pudo obtener datos del endpoint');
        throw new Error('No se pudo obtener datos del endpoint');
      }
    } catch (error) {
      console.error('Error:', error);
      throw error;
    } finally {
      this.loading = false;
    }
  }

  async getParentMenus(): Promise<void> {
    try {
      const body = new FormData();
      const result: any = await this.crudService.crud(body, environment.GetParentMenus).toPromise();
      if (result && result.status === 1 && result.data && result.data.length > 0) {
        this.AllChildrenMenus = Object.values(result.data);
      } else {
        console.error('Error: No se pudo obtener datos del endpoint');
        throw new Error('No se pudo obtener datos del endpoint');
      }
    } catch (error) {
      console.error('Error:', error);
      throw error;
    } finally {
      this.loading = false;
    }
  }

  toggleExpanded(app: any) {
    app.expanded = !app.expanded;
  }

  toggleVisibility(app: any) {
    app.visibility = !app.visibility;
  }

  onActiveItemChange(event: ElementRef): void {
  }

  /* END TAB MENU */
 selectAllItems(event: any) {
  if (event.target.checked) {
    // Marcar todos los checkboxes y agregar sus IDs a this.itemsMenuSelected
    this.itemsMenuSelected = [];
    this.toggleCheckboxes(this.MenuItems, 1);
  } else {
    // Desmarcar todos los checkboxes y vaciar this.itemsMenuSelected
    this.itemsMenuSelected = [];
    this.toggleCheckboxes(this.MenuItems, 0);
  }
}

toggleCheckboxes(items: any[], isChecked: number) {
  console.log(items)
  items.forEach(item => {
    // Marcar visualmente el checkbox según la condición
    item.UserHasMenu = isChecked;

    if (item.submenus) {
      // Si hay submenús, llamar recursivamente a la función para ellos
      this.toggleCheckboxes(item.submenus, isChecked);
    }

    // Si es un submenú o es un elemento de MenuItems sin submenús
    if (isChecked && (item.submenus || !item.submenus)) {
      // Si es un elemento de MenuItems con submenús, recorrer los submenús y obtener los submenuId
      if (item.submenus) {
        item.submenus.forEach((submenu: { submenuId: string; }) => {
          const submenuId = parseInt(submenu.submenuId);
          if (!isNaN(submenuId) && !this.itemsMenuSelected.includes(submenuId)) {
            this.itemsMenuSelected.push(submenuId);
          }
        });
      }

      // Si es un elemento de MenuItems sin submenús, obtener el menuId
      const menuId = parseInt(item.menuId);
      if (!isNaN(menuId) && !this.itemsMenuSelected.includes(menuId)) {
        this.itemsMenuSelected.push(menuId);
      }
    }
  });
}

  pushOrPopMenuElement(event: any, menuId: number) {
    console.log(menuId)

    if (event.checked) {
      if (!this.itemsMenuSelected.includes(menuId)) {
        this.itemsMenuSelected.push(menuId);
      }
    } else {
      const index = this.itemsMenuSelected.indexOf(menuId);
      if (index !== -1) {
        this.itemsMenuSelected.splice(index, 1);
      }
    }
  }


  associateMenuToUser(): void {
    console.log(this.itemsMenuSelected)
    let title_ = "¿Realmente desea guardar la selección de Menu realizada ?"
    let titleConfirm = "actualizado"
    let MenuObj = {
      id_user: this.selectedUser * 1,
      menus: this.itemsMenuSelected,
      id_company: this.permissionForm.value.companiesControlName * 1,
      id_app: this.permissionForm.value.appControlName * 1,
    }

    Swal.fire({
      title: title_,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Sí',
      cancelButtonText: 'Cancelar',
      allowOutsideClick: false
    }).then((result) => {
      if (result.isConfirmed) {
        Swal.fire({
          title: 'Procesando...',
          allowOutsideClick: false,
          showCancelButton: false,
          showCloseButton: false,
          showConfirmButton: false,
          willOpen: () => {
            Swal.showLoading();
            this.crudService.crud(MenuObj, environment.associateMenuToUser).toPromise().then(() => {
              this.getAllCompanies();
              this.onAppSelectedTabPermission(this.permissionForm.value.appControlName)
              Swal.fire({
                icon: 'success',
                title: 'Menu ' + titleConfirm + ' correctamente',
                showConfirmButton: false,
                timer: 1000
              });
              this.itemsMenuSelected = []
            }).catch((error) => {
              // Control de error en caso de que falle la eliminación en el servidor
              Swal.fire({
                icon: 'error',
                title: 'Error al asignar elementos de Menú',
                text: error.message,
                allowOutsideClick: false,
              });
            });
          }
        });
      }
    });

    this.loadingFull = false;
  }

  async openModalCloneProfile(AllUsers: any): Promise<void> {
    console.log("allUsers: ", AllUsers);
    this.modalRefCloneProfile = this.modalService.open(ModalCloneProfileComponent, {
      data: {
        allUsers: AllUsers,
      },
      ignoreBackdropClick: true,
    });
    this.modalRefCloneProfile.onClose.subscribe((modalData: Company) => {
      if (!modalData) {
        return;
      }
    });
  }
}